export default __webpack_public_path__ + "static/media/instagram.ee4bf439.svg";